import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = { class: "text-truncate" }
const _hoisted_3 = { class: "text-truncate" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fs-4" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "text-truncate" }
const _hoisted_11 = { class: "text-truncate" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-v fs-5" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_vz_user_clone_modal = _resolveComponent("vz-user-clone-modal")!
  const _component_vz_bulk_active = _resolveComponent("vz-bulk-active")!
  const _component_vz_user_Phone_modal = _resolveComponent("vz-user-Phone-modal")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_vz_add_edit_modal = _resolveComponent("vz-add-edit-modal")!
  const _component_vz_create_modal = _resolveComponent("vz-create-modal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      viewName: "userAccounts",
      tableForm: _ctx.formData,
      activityTab: false,
      addButtonText: `${_ctx.t('pages.user.addUser')}`,
      bulkStatusUpdate: _ctx.bulkStatusUpdate,
      onQueryUpdate: _ctx.queryUpdate,
      onTableRowClick: _ctx.tableRowClick,
      onFormSubmit: _ctx.submit,
      onCreateUserAccount: _ctx.createUserAccount,
      onBulkStatusUpdate: _ctx.webIdDataStore,
      permissions: _ctx.permissionModel
    }, {
      "cell-firstName": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(user.firstName), 1)
      ]),
      "cell-lastName": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(user.lastName), 1)
      ]),
      "cell-email": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_3, _toDisplayString(user.email), 1)
      ]),
      "cell-phoneNumber": _withCtx(({ row: user }) => [
        (user.userPhone?.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (user.userPhone.find((phone) => phone.default_phone))
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    title: 
            user.userPhone.find((phone) => phone.default_phone).phone_number
          ,
                    class: "text-truncate"
                  }, _toDisplayString(user.userPhone.find((phone) => phone.default_phone).phone_number), 9, _hoisted_4))
                : (user.userPhone[0])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      title: user.userPhone[0].phone_number,
                      class: "text-truncate"
                    }, _toDisplayString(user.userPhone[0].phone_number), 9, _hoisted_5))
                  : _createCommentVNode("", true),
              (user.userPhone.length > 1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon sm-icon btn-circle btn-sm ms-3 text-truncate",
                    onClick: _withModifiers(($event: any) => (_ctx.setUserPhoneData(user.userPhone)), ["stop"])
                  }, _hoisted_8, 8, _hoisted_6))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      "cell-site": _withCtx(({ row: user }) => [
        (user.userSites)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              title: user.userSites?.map((site) => site?.site_name)?.join(','),
              class: "text-truncate"
            }, _toDisplayString(user.userSites?.map((site) => site?.site_name)?.join(",")), 9, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      "cell-startDate": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.format.convertUTCToLocalDate(user.startDate)), 1)
      ]),
      "cell-endDate": _withCtx(({ row: user }) => [
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.format.convertUTCToLocalDate(user.endDate)), 1)
      ]),
      "cell-status": _withCtx(({ row: user }) => [
        _createElementVNode("span", {
          class: _normalizeClass(["text-truncate fw-bold", {
          'badge badge-success bg-success':
            user.status?.toLowerCase() === 'active',
          'badge badge-danger bg-danger':
            user.status?.toLowerCase() !== 'active',
        }])
        }, _toDisplayString(_ctx.format.TitleCase(user.status?.toLowerCase() || "")), 3)
      ]),
      "cell-actions": _withCtx(({ row: user }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              "data-bs-toggle": "modal",
              "data-bs-target": `#user__UpdateUserModal`,
              class: "btn btn-icon btn-primary btn-circle btn-sm",
              onClick: _withModifiers(
          () => {
            _ctx.openModal = true;
            _ctx.selectedForAction = user;
          }
        , ["stop"])
            }, _hoisted_14, 8, _hoisted_12))
          : _createCommentVNode("", true),
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = user;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_17, 8, _hoisted_15))
          : _createCommentVNode("", true)
      ]),
      "cell-clone": _withCtx(({ row: user }) => [
        _createElementVNode("button", {
          onClick: _withModifiers(($event: any) => (_ctx.resetWebId(user.webId)), ["stop"]),
          type: "button",
          "data-bs-toggle": "dropdown",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary btn-icon btn-circle btn-sm ms-3",
          "aria-expanded": "false"
        }, _hoisted_20, 8, _hoisted_18),
        _createElementVNode("ul", {
          class: _normalizeClass(["dropdown-menu dropdown-menu-end border user-clone", 'show-clone-' + user.webId])
        }, [
          _createElementVNode("li", null, [
            (_ctx.hasPermission(_ctx.permissionModel.create))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _withModifiers(($event: any) => (_ctx.setUserCloneData(user)), ["stop"]),
                  class: "dropdown-item py-2 text-hover-primary",
                  type: "button"
                }, _toDisplayString(_ctx.t("pages.user.clone.title")), 9, _hoisted_21))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "bulkStatusUpdate", "onQueryUpdate", "onTableRowClick", "onFormSubmit", "onCreateUserAccount", "onBulkStatusUpdate", "permissions"]),
    (_ctx.openCloneModal)
      ? (_openBlock(), _createBlock(_component_vz_user_clone_modal, {
          key: 0,
          user: _ctx.userObj,
          onCloneSubmit: _ctx.refreshList,
          onOnCancel: _ctx.closeModel
        }, null, 8, ["user", "onCloneSubmit", "onOnCancel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_vz_bulk_active, { onStatusModalValue: _ctx.bulKuserActive }, null, 8, ["onStatusModalValue"]),
    _createVNode(_component_vz_user_Phone_modal, {
      phone: _ctx.phoneObj,
      showDialog: _ctx.showPhoneDialog,
      onModalClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPhoneDialog = false)),
      onCloseDetail: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPhoneDialog = false))
    }, null, 8, ["phone", "showDialog"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 1,
          showDialog: _ctx.showDeleteDialog,
          viewName: "userAccounts",
          selectedForAction: [_ctx.selectedForAction.webId],
          deleteText: `${_ctx.t('validation.sureToDelete')} ${
      _ctx.selectedForAction.firstName
    } ${_ctx.selectedForAction.lastName}?`,
          pageName: "user",
          onClose: _ctx.refreshList
        }, null, 8, ["showDialog", "selectedForAction", "deleteText", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_vz_add_edit_modal, {
      selectedForAction: _ctx.selectedForAction,
      siteOption: _ctx.options,
      onClose: _cache[4] || (_cache[4] = 
      () => {
        _ctx.openModal = false;
        _ctx.refreshList();
      }
    ),
      onResetForm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal = false)),
      modelValue: _ctx.openModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openModal) = $event))
    }, null, 8, ["selectedForAction", "siteOption", "modelValue"]),
    (_ctx.showAddModel)
      ? (_openBlock(), _createBlock(_component_vz_create_modal, {
          key: 2,
          selectedForAction: _ctx.selectedForAction,
          siteOption: _ctx.options,
          onClose: _ctx.refreshList,
          onCloseModel: _ctx.closeModel
        }, null, 8, ["selectedForAction", "siteOption", "onClose", "onCloseModel"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "bi bi-people fs-3",
      viewName: "Users Activity Pulse",
      type: "300,1400,1100,2000,2300"
    }, null, 8, ["refresh"])
  ], 64))
}